<template>
  <div class="users-detail-info" v-loading="loading">
    <ul class="info-form">
      <li class="form-item">
        <span class="form-item-label">头像：</span>
        <div class="form-item-content">
          <img v-pic.oauth.avatar="profile.avatar" />
        </div>
      </li>
      <li class="form-item">
        <span class="form-item-label">用户ID：</span>
        <div class="form-item-content">
          {{ userData.userId }}
        </div>
      </li>
      <li class="form-item">
        <span class="form-item-label">手机号：</span>
        <div class="form-item-content">
          {{ userData.mobile ?  userData.mobile :"--"}}
        </div>
      </li>
      <li class="form-item">
        <span class="form-item-label">邮箱：</span>
        <div class="form-item-content">
          {{ userData.email  ?  userData.email :"--"}}
        </div>
      </li>
      <li class="form-item">
        <span class="form-item-label">用户名：</span>
        <div class="form-item-content">
          <i class="el-icon-circle el-icon-user-solid" style="background-color:#00bd83;"></i>
          <span>{{ userData.username }}</span>
        </div>
      </li>
      <li class="form-item">
        <span class="form-item-label">昵称：</span>
        <div class="form-item-content">
          <!--<i class="el-icon-circle el-icon-user-solid" style="background-color:#00bd83;"></i>-->
          <span>{{ profile.nickname }}</span>
        </div>
      </li>
      <li class="form-item">
        <span class="form-item-label">性别：</span>
        <div class="form-item-content">
          <template v-if="profile.sex === 'M'">
            <i class="el-icon-male"></i>
            <span>男</span>
          </template>
          <template v-else-if="profile.sex === 'F'">
            <i class="el-icon-female"></i>
            <span>女</span>
          </template>
          <span v-else>- -</span>
        </div>
      </li>
      <li class="form-item">
        <span class="form-item-label">居住地：</span>
        <div class="form-item-content">
          {{ profile.city ? profile.city.replace(/,/g, ' ') : '- -' }}
        </div>
      </li>
      <!--<li class="form-item">-->
      <!--<span class="form-item-label">家乡：</span>-->
      <!--<div class="form-item-content">-->
      <!--{{ profile.city ? profile.hometown.replace(/,/g,' ') : '- -' }}-->
      <!--</div>-->
      <!--</li>-->
      <li class="form-item">
        <span class="form-item-label">注册时间：</span>
        <div class="form-item-content">
          {{ userData.createdDate }}
        </div>
      </li>
      <li class="form-item">
        <span class="form-item-label">是否绑定了微信：</span>
        <div class="form-item-content">
          <svg
            t="1615786166973"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="3747"
            width="20"
            height="20"
          >
            <path
              d="M512 1.896C229.452 1.896 0 229.452 0 512s229.452 510.104 512 510.104S1022.104 794.548 1022.104 512 794.548 1.896 512 1.896z m-91.022 629.57c-26.548 0-49.304-5.688-75.852-11.377l-75.852 37.926 22.756-66.37c-54.993-37.926-87.23-87.23-87.23-147.912 0-104.296 98.607-185.837 218.074-185.837 108.089 0 201.007 64.474 219.97 153.6-7.585 0-13.274-1.896-20.859-1.896-104.296 0-185.837 77.748-185.837 172.563 0 15.17 1.896 30.34 7.585 45.511-7.585 3.793-15.17 3.793-22.755 3.793z m322.37 77.749l17.067 54.992-58.785-34.133c-22.756 5.689-43.615 11.378-66.37 11.378-104.297 0-185.838-70.163-185.838-157.393S530.963 424.77 635.26 424.77c98.608 0 185.837 70.163 185.837 159.29 0 47.407-32.237 91.021-77.748 125.155z"
              fill="#46BB36"
              p-id="3748"
            ></path>
            <path
              d="M318.578 379.26c0 17.066 13.274 30.34 30.34 30.34s30.341-13.274 30.341-30.34-13.274-30.341-30.34-30.341-30.341 13.274-30.341 30.34z m235.14 159.288c0 13.274 11.378 24.652 24.652 24.652 13.274 0 24.652-11.378 24.652-24.652 0-13.274-11.378-24.652-24.652-24.652-13.274-1.896-24.651 9.482-24.651 24.652z m-81.54-159.289c0 17.067 13.274 30.341 30.34 30.341 17.067 0 30.341-13.274 30.341-30.34 0-17.067-13.274-30.341-30.34-30.341-17.067 0-30.341 13.274-30.341 30.34zM675.08 538.55c0 13.273 11.378 24.651 24.652 24.651 13.274 0 24.652-11.378 24.652-24.652 0-13.274-11.378-24.652-24.652-24.652-13.274-1.896-24.652 9.482-24.652 24.652z"
              fill="#46BB36"
              p-id="3749"
            ></path>
          </svg>
          <el-switch :value="bind.wx" active-color="#f06950" inactive-color="#eeeeee" style="margin-right:8px;"></el-switch>
          <span>{{ bind.wx ? '是' : '否' }}</span>
        </div>
      </li>
      <li class="form-item">
        <span class="form-item-label">是否绑定了QQ：</span>
        <div class="form-item-content">
          <svg
            t="1615786078376"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2175"
            width="20"
            height="20"
          >
            <path
              d="M512.268258 64.433103c-247.183323 0-447.569968 200.380501-447.569968 447.563825 0 247.189467 200.385621 447.570992 447.569968 447.570992s447.569968-200.380501 447.569968-447.569968c0-247.184347-200.386645-447.564849-447.569968-447.564849z m252.85872 584.692787c-18.997168 16.287968-43.668709-53.628042-47.2134-42.875198-8.642616 26.161294-12.695154 43.646184-38.148944 72.127602-1.35972 1.521494 29.43056 12.647032 38.148944 36.396051 8.346713 22.756875 24.596797 58.811973-81.725503 70.125906-62.389428 6.635801-107.471099-33.244533-111.964932-32.85648-8.325212 0.734126-4.618747 0-13.568528 0-7.321804 0-7.807126 0.534468-14.69685 0-1.899307-0.140272-22.632985 32.85648-115.364231 32.85648-71.878798 0-90.48177-45.243445-76.032701-70.125906 14.464428-24.877342 38.579999-32.122354 35.176604-36.06636-16.73643-19.39546-28.287904-40.1404-35.176604-58.882621-1.705793-4.666869-3.135137-9.209848-4.262434-13.574672-2.611931-10.008479-22.627866 58.76385-44.111028 42.875198-21.483162-15.883533-19.567472-56.309597-5.659014-95.003248 14.033372-39.006959 49.37687-76.562049 49.771065-84.854496 1.412962-30.849665-3.044011-35.975235 0-44.078263 6.780169-18.149391 15.034732-11.190043 15.034733-20.609788 0-118.64476 88.172909-214.829571 196.933079-214.829571 108.755051 0 196.928984 96.184811 196.928984 214.829571 0 4.554242 11.815637 0 17.474651 20.609788 1.165181 4.256291 1.968931 20.684531 0.58771 44.078263-0.658358 11.238165 29.954789 24.914202 45.777913 84.854496 15.845649 59.945414 0 88.215912-7.909514 95.003248z"
              fill="#68A5E1"
              p-id="2176"
            ></path>
          </svg>
          <el-switch :value="bind.qq" active-color="#f06950" inactive-color="#eeeeee" style="margin-right:8px;"></el-switch>
          <span>{{ bind.qq ? '是' : '否' }}</span>
        </div>
      </li>
      <li class="form-item">
        <span class="form-item-label">是否开设了店铺：</span>
        <div class="form-item-content">
          <i class="el-icon-circle el-icon-s-shop" style="background-color:#005bff;"></i>
          <el-switch :value="openShop" active-color="#f06950" inactive-color="#eeeeee" style="margin-right:8px;"></el-switch>
          <span>{{ openShop ? '是' : '否' }}</span>
        </div>
      </li>
      <li class="form-item">
        <span class="form-item-label">启/禁用状态：</span>
        <div class="form-item-content">
          <el-switch :value="userData.enabled" active-color="#005bff" inactive-color="#eeeeee" style="margin-right:8px;"></el-switch>
          <span>{{ userData.enabled ? '启用' : '禁用' }}</span>
        </div>
      </li>
    </ul>
    <div class="btn-grp">
      <el-button :disabled="userData.enabled" @click="enable">启用</el-button>
      <el-button :disabled="!userData.enabled" @click="disable">禁用</el-button>
    </div>
  </div>
</template>

<script>
import { changeMobileById, disableUserById, enableUserById, findCreatorByCreator, getUserById } from '@/api/req';
export default {
  name: 'userDetailInfo',
  data() {
    return {
      userData: {},
      openShop: false,
      loading: true
    };
  },
  computed: {
    userId() {
      return this.$route.params.id || 0;
    },
    subId() {
      return this.$route.params.subId || 0;
    },
    profile() {
      return this.userData.profile || {};
    },
    bind() {
      const { socialUserBindings = {} } = this.userData;
      return {
        wx: Boolean(socialUserBindings.wx && socialUserBindings.wx.id),
        qq: Boolean(socialUserBindings.qq && socialUserBindings.qq.id)
      };
    }
  },
  methods: {
    getData() {
      this.loading = true;
      this.$ajax
        .get(getUserById(this.userId))
        .then(({ data }) => {
          this.loading = false;
          this.userData = data;
        })
        .catch(err => {
          this.loading = false;
          console.log('err.data :>> ', err.data);
          this.$message.info(`加载失败，${err.data}`);
        });
    },
    creator() {
      this.$ajax
        .get(findCreatorByCreator, {
          createdBy: this.subId
        })
        .then(({ data }) => {
          this.openShop = data?.state === 'CERTIFIED';
          // if (data) this.openShop = true;
          // else this.openShop = false;
        })
        .catch(err => {
          this.openShop = false;
          console.log('err :>> ', err);
        });
    },
    enable() {
      this.$ajax
        .put(enableUserById(this.userId))
        .then(({ data }) => {
          this.$message.success('操作成功');
          this.userData = Object.assign(this.userData, data);
        })
        .catch(err => {
          this.$message.info('操作失败');
          console.log('err.data :>> ', err.data);
        });
    },
    disable() {
      this.$ajax
        .put(disableUserById(this.userId))
        .then(({ data }) => {
          this.$message.success('操作成功');
          this.userData = Object.assign(this.userData, data);
        })
        .catch(err => {
          this.$message.info('操作失败');
          console.log('err.data :>> ', err.data);
        });
    },
    changeMobile() {
      this.$prompt('请输入新手机号', '更改手机号', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-79])|(?:5[0-35-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[189]))\d{8}$/,
        inputErrorMessage: '手机号有误，请重新输入'
      }).then(({ value }) => {
          this.$ajax.put(changeMobileById(this.userId), {
              id: this.userId,
              newMobile: value
          }).then(res => {
            this.$message.success('更新成功')
            this.getData()
          }).catch(err => {
            this.$message.info('更新失败');
          });
      }).catch(() => {});
    }
  },
  created() {
    this.getData();
    this.creator();
  }
};
</script>

<style lang="scss">
.users-detail-info {
  height: 100%;
  ul,
  li {
    list-style: none;
  }
  .info-form {
    margin-bottom: 16px;
    padding: 24px 20px;
    background-color: white;
    border-radius: 4px;
  }
  .btn-grp {
    padding: 24px 20px;
    background-color: white;
    border-radius: 4px;
    .el-button {
      padding: 13px 30px;
      border-color: #002b9c;
      color: #002b9c;
      &:not(.is-disabled):hover {
        background-color: #002b9c;
        color: white;
      }
    }
    .is-disabled {
      border: 1px dashed #8998a0;
      color: #8998a0;
    }
  }
  .form-item {
    margin-top: 20px;
    display: flex;
    align-items: center;
    &:first-child {
      margin-top: 0;
    }
    &-label {
      height: 20px;
      font-size: 12px;
      font-weight: 500;
      color: #8998a0;
      line-height: 20px;
      width: 100px;
      margin-right: 6px;
    }
    &-content {
      font-size: 14px;
      font-weight: 400;
      color: #040b28;
      line-height: 20px;
      .icon {
        display: inline-block;
        vertical-align: middle;
        margin-right: 8px;
      }
      img {
        height: 94px;
        width: 94px;
        border-radius: 4px;
        font-size: 0;
        vertical-align: bottom;
        object-fit: cover;
      }
      .el-icon-circle {
        margin-right: 8px;
        color: #fff;
        vertical-align: middle;
      }
    }
  }
  .text-action {
    font-weight: 400;
    color: #19b0ea;
    cursor: pointer;
    margin-left: 12px;
    &:hover {
      color: #59c5f0;
    }
  }
}
</style>
